/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { EthanolCentrifuge } from "./modelEthanolCentrifuge";

class ControllerEthanolCentrifuge extends ControllerModel {
  constructor() {
    super("ControllerEthanolCentrifuge");

    this.setNewNode = (callback) => {
      let ethanolCentrifuge = new EthanolCentrifuge();
      ethanolCentrifuge.decorate(callback);

      this.addNode(ethanolCentrifuge);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let ethanolCentrifuge = new EthanolCentrifuge();
      ethanolCentrifuge.copyFrom(node);
      ethanolCentrifuge.decorate(callback);
      this.addNode(ethanolCentrifuge);
    };

    this.getProperties = async (node) => {
      let n = new EthanolCentrifuge();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new EthanolCentrifuge();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerEthanolCentrifuge };
